import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class DocumentLifecycleService {
  baseUrl = 'document-lifecycle';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  create = (document) => BaseService.post({ url: `${this.baseUrl}`, data: document });
  update = (id, document) => BaseService.put({ url: `${this.baseUrl}/${id}`, data: document });
  getById = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
}

export default new DocumentLifecycleService();
